import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'

function* fetchWheelsExchangeConfig(action) {
  const {type} = action.request;
  try {
    const configuration = yield call(function () {
      return Api.get('/wheels-exchange/configuration', action.request);
    });
    yield put({type: `FETCH_${type}_EXCHANGE_CONFIG.SUCCESS`, configuration})
  } catch (error) {
    yield put({type: `FETCH_${type}_EXCHANGE_CONFIG.ERROR`, error})
  }
}

function* fetchWheelsExchangeSummary(action) {
  const {type} = action.request;
  try {
    const days= yield call(function () {
      return Api.get(`/wheels-exchange/${type}/summary`);
    });
    yield put({type: `FETCH_${type}_EXCHANGE_SUMMARY.SUCCESS`, days})
  } catch (error) {
    yield put({type: `FETCH_${type}_EXCHANGE_SUMMARY.ERROR`, error})
  }
}

function* updateWheelsExchangeConfig(action) {
  const {type} = action.request;
  try {
    const configuration = yield call(function () {
      return Api.put('/wheels-exchange/configuration', action.request);
    });
    yield put({type: `UPDATE_${type}_EXCHANGE_CONFIG.SUCCESS`, configuration})
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    // yield put({type: 'SHOW_NOTIFICATION', notification: {type: ERROR_MESSAGE, message:'error.generic'}});
    yield put({type: `UPDATE_${type}_EXCHANGE_CONFIG.FAILURE`, error})
  }
}

export function* watchFetchWheelsExchangeConfig() {
  yield takeEvery('FETCH_WHEELS_EXCHANGE_CONFIG.REQUEST', fetchWheelsExchangeConfig);
  yield takeEvery('FETCH_TIRES_EXCHANGE_CONFIG.REQUEST', fetchWheelsExchangeConfig);
  yield takeEvery('FETCH_WHEELS_EXCHANGE_SUMMARY.REQUEST', fetchWheelsExchangeSummary);
  yield takeEvery('FETCH_TIRES_EXCHANGE_SUMMARY.REQUEST', fetchWheelsExchangeSummary);
  yield takeEvery('UPDATE_WHEELS_EXCHANGE_CONFIG.REQUEST', updateWheelsExchangeConfig);
  yield takeEvery('UPDATE_TIRES_EXCHANGE_CONFIG.REQUEST', updateWheelsExchangeConfig);
}



// WEBPACK FOOTER //
// ./src/sagas/wheelsExchangeConfig.js